module.exports = __webpack_public_path__ + "img/coeur.5014ff35.png";